export const page = {
	title: "Produits",
	description: "Liste et configuration des articles vendus aux clients finaux.",
	permissionError: "Vous n'avez pas les autorisations",
	addProduct: "Ajouter un produit",
	bulkImportProducts: "Importer des produits en masse",
};
